import {APIClient} from "../../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Login Method
export const postLogin = (data: any) => api.create(url.POST_LOGIN, data);
